/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddSecondaryTokensRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'
import {AddSecondaryTokensResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'


export const addSecondaryTokens = (request: AddSecondaryTokensRequest, options?: CashRequestOptions) => post<AddSecondaryTokensRequest, AddSecondaryTokensResponse>("/2.0/cash/add-secondary-tokens", request, {...options, rejectOnError: true })